export default __webpack_public_path__ + "static/media/ladrillos-consejo-2.6df957fa.jpg";